import type { AppDispatch } from './store';

let _dispatch: AppDispatch | undefined;

export function setStoreAccessors(dispatch: AppDispatch) {
  _dispatch = dispatch;
}

export const appDispatch: AppDispatch = ((action: Parameters<AppDispatch>[0]) => {
  if (!_dispatch) throw new Error('Dispatch not set yet. Ensure store is created and setStoreAccessors called.');
  return _dispatch(action);
}) as AppDispatch;
